<div class="mb-3">
  <div>
    <h1 class="pb-2 border-bottom fw-light" i18n>Auftrag bearbeiten</h1>

    @if (orderForm) {
      <form [formGroup]="orderForm">
        <div class="row">
          <div class="col-sm-6">
            <div class="row mb-2">
              <label class="col-sm-4 col-form-label col-form-label-sm" i18n>Bestellnummer</label>
              <div class="col-sm-8">
                <input
                  type="text"
                  readonly
                  class="form-control form-control-sm form-control-plaintext"
                  id="orderNumber"
                  formControlName="orderNumber"
                  />
              </div>
            </div>
            <div class="row mb-2">
              <label class="col-sm-4 col-form-label col-form-label-sm" i18n>Kundennummer</label>
              <div class="col-sm-8">
                <input
                  type="text"
                  readonly
                  class="form-control form-control-sm form-control-plaintext"
                  id="customerNumber"
                  formControlName="buyerCustomerNumber"
                  />
              </div>
            </div>
            <div class="row mb-2">
              <label class="col-sm-4 col-form-label col-form-label-sm" i18n>Kundenname</label>
              <div class="col-sm-8">
                <input
                  type="text"
                  readonly
                  class="form-control form-control-sm form-control-plaintext"
                  id="customerNumber"
                  formControlName="buyerCustomerFullName"
                  />
              </div>
            </div>
            <div class="row mb-2">
              <label class="col-sm-4 col-form-label col-form-label-sm" i18n>Einkauf am</label>
              <div class="col-sm-8">
                <input
                  type="text"
                  readonly
                  class="form-control form-control-sm form-control-plaintext"
                  id="orderDateTime"
                  formControlName="orderDateTime"
                  />
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="row mb-2">
              <label class="col-sm-4 col-form-label col-form-label-sm" i18n>Rechnung erstellt</label>
              <div class="col-sm-8">
                <input
                  type="text"
                  readonly
                  class="form-control form-control-sm form-control-plaintext"
                  id="orderIsInvoiced"
                  formControlName="orderIsInvoiced"
                  />
              </div>
            </div>
            <div class="row mb-2">
              <label class="col-sm-4 col-form-label col-form-label-sm" i18n>Rechnungsnummer</label>
              <div class="col-sm-8">
                <input
                  type="text"
                  readonly
                  class="form-control form-control-sm form-control-plaintext"
                  id="invoiceNumber"
                  formControlName="invoiceNumber"
                  />
              </div>
            </div>
            <div>
              <div class="row mb-2">
                <label class="col-sm-4 col-form-label col-form-label-sm" i18n>Rechnungsstatus</label>
                <div class="col-sm-8">
                  <input
                    name="isReadyForInvoice"
                    id="isReadyForInvoice"
                    type="checkbox"
                    formControlName="isReadyForInvoice"
                    />
                  <label for="isReadyForInvoice" class="ms-2 mt-2" i18n
                    >Für Rechnung freigegeben</label
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <button class="btn btn-secondary m-2" type="button" (click)="onBackClicked()" i18n>
        Zurück
      </button>
          <button
            class="btn btn-primary m-2"
            type="button"
            [asyncClick]="onSetInvoiceReadyStatus.bind(this)"
            [disabled]="confirmBtn.disabled || orderForm.pristine || orderForm.invalid"
            #confirmBtn="asyncClick"
            i18n
            >
        @if (confirmBtn.busy) { <span class="spinner-border spinner-border-sm me-1"></span> }
        Bestätigen
      </button>
          @if (order?.id) {
            <a
              class="btn btn-outline-secondary m-2"
              data-testid="order-receipt-button"
              [routerLink]="['/order-receipt', order.id]"
              i18n
              >
              <fa-icon [icon]="faPrint"></fa-icon> Beleg drucken
            </a>
          }
        </form>
      }

      <div class="mt-4">
        <kendo-pdf-export #pdf paperSize="A4" margin="2cm" [scale]="0.75">
          <div class="table-responsive">
            <table class="table table-striped table-sm">
              <thead>
                <tr>
                  <th i18n>Pos-Nr.</th>
                  <th i18n>Artikel</th>
                  <th i18n>Menge</th>
                  <th i18n>Netto</th>
                  <th i18n>Brutto</th>
                  <th i18n>Gesamtpreis</th>
                  <th i18n>Status</th>
                </tr>
              </thead>
              <tbody>
                @for (orderPos of order.orderPositions; track orderPos) {
                  <tr class="nav-row">
                    <td>{{ orderPos.positionNumber }}</td>
                    <td>{{ orderPos.skuName1 }}</td>
                    <td>{{ orderPos.quantity }}</td>
                    <td>{{ orderPos.unitNetPrice | currency: orderPos.currency }}</td>
                    <td>{{ orderPos.unitGrossPrice | currency: orderPos.currency }}</td>
                    <td>{{ orderPos.grossPrice | currency: orderPos.currency }}</td>
                    <td>{{ orderPos.status | orderPositionStatusDisplayName }}</td>
                    @if (profile?.isActive) {
                      <td>
                        @if (orderPos.status == OrderPositionStatusConstants.PositionStatusIdCancellationPending) {
                          <button
                            class="btn btn-sm btn-secondary"
                            type="button"
                            [asyncClick]="onApproveOrderPosition(orderPos.id)"
                            [disabled]="approveBtn.disabled"
                            #approveBtn="asyncClick"
                            i18n
                            >
                    @if (approveBtn.busy) { <span class="spinner-border spinner-border-sm me-1"></span> }
                    <fa-icon [icon]="faCheck"></fa-icon> Genehmigen
                  </button>
                        }
                        @if (orderPos.status == OrderPositionStatusConstants.PositionStatusIdCancellationPending) {
                          <button
                            class="btn btn-sm btn-secondary ms-1"
                            type="button"
                            [asyncClick]="onRejectOrderPosition(orderPos.id)"
                            [disabled]="rejectBtn.disabled"
                            #rejectBtn="asyncClick"
                            i18n
                            >
                    @if (rejectBtn.busy) { <span class="spinner-border spinner-border-sm me-1"></span> }
                    <fa-icon [icon]="faWindowClose"></fa-icon> Ablehnen
                  </button>
                        }
                      </td>
                    }
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </kendo-pdf-export>
      </div>
    </div>
  </div>
